export const EMPLOYEE_ID_REGEX = /^[0-9]+\.\d+$/;
